import type { TPrePromptVariantKey, TZaiPromptButtonVariant } from './zai.types'

class ZaiUtils {
  transformPrePromptKeyToVariant(
    key: TPrePromptVariantKey | undefined,
    defaultVariant: TZaiPromptButtonVariant = 'default'
  ): TZaiPromptButtonVariant {
    switch (key) {
      case 'CHRISTMAS':
        return 'christmas'
      default:
        return defaultVariant
    }
  }
}

export const zaiUtils = new ZaiUtils()
